import {Component, OnInit, ViewChild} from "@angular/core";
import {UntypedFormBuilder, FormGroup, Validators, FormControl} from "@angular/forms";
import { Observable, combineLatest, throwError } from 'rxjs';

import {LogService} from "../Abstract/log.service";
import {ConfigService} from "../../Core/Abstract/config.service";
import {EventsEmitterService} from "../../Core/Abstract/emitter.service";
import {PasswordValidatorOptions, passwordValidator} from "../Login/passwordValidator.component";
import {matchOtherValidator} from "../Login//matchOtherValidator.component";
import {RegisterService} from "./register.service";
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ActivatedRoute } from "@angular/router";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'confirm',
    templateUrl: 'confirm.component.html',
    providers: [RegisterService]
})

export class ConfirmComponent {


    @ViewChild('msgModal',{static: false}) public msgModal: ModalDirective;
    /*
     *  Modal handling
     */
    currentLang =  this.configService.getCurrentLocaleStr();

    public showChildModal(): void {
        this.msgModal.show();
    }

    public hideChildModal(): void {
        this.msgModal.hide();
    }

    protected redirectTitle = "";
    protected redirectMsg = "";
    private validateTokenHasError:boolean = false;

    private loading: boolean = false;

    pwderror = false;
    conferror = false;
    
    pwdmsg = null;
    protected token:string = "";
    protected mail:string = "";

    constructor(private router: Router , private confirmService: RegisterService, private logger: LogService, private fb: UntypedFormBuilder,public translate:TranslateService,
                private configService: ConfigService, private eventsEmitterService :EventsEmitterService, private route:ActivatedRoute) {
        
        if (localStorage.getItem('confirm') != null && localStorage.getItem('confirm') != "" ){
            this.mail = localStorage.getItem('confirm');
            localStorage.removeItem('confirm');
        }
        localStorage.setItem('langId', this.configService.getLangDefault() ? this.configService.getLangDefault().toString() : '2' );

    }

    ngOnInit(){
        let obsComb = combineLatest(this.route.params, this.route.queryParams, 
            (params, qparams) => ({ params, qparams }));
          
        obsComb.subscribe(ap => {
            this.logger.log(ap)
            if(ap.params['token']){
                this.token = ap.params['token'];
            }
            if(ap.qparams['token']){
                this.token = ap.qparams['token'];
            }
            if(ap.params.lang){
                this.changeLang(ap.params.lang);
            }
            this.doConfirm();
        });
    }

    public returnToLogin(){
        this.confirmService.goToLogin();
    }

    public doConfirm(){
        this.loading = true;
        this.pwderror = false;

        this.confirmService.confirmRequest(this.token).subscribe(
            data => {
                this.loading = false;
                if(data == 'expired'){
                    this.validateTokenHasError = true
                    this.redirectTitle = 'Your token has expired';
                    this.redirectMsg = 'Resend Verification Mail!'
                    this.showChildModal();
                }
               else if(data == 'invalidToken'){
                this.validateTokenHasError = true
                this.redirectTitle = 'Your token is invalid';
                this.redirectMsg = 'Your token is invalid'
                this.showChildModal();
               }else{
                this.logger.log(data);
                this.loading = false;

                this.redirectTitle = 'Confirmed Successfully';
                this.redirectMsg = 'You can now login to your account.';

               }
                this.showChildModal();
                },
            error => {
                this.loading = false;
                this.pwderror = true;

                this.logger.error(error);
                return throwError(error);
            }
            
        );   
    }

    public doResend(){
        this.loading = true;

        this.confirmService.resendTokenRequest(this.token,this.mail).subscribe(
            data => {
                this.logger.log(data);
                this.loading = false;

                this.redirectTitle = 'Resent Mail Successfully';
                this.redirectMsg = 'A verification email has been sent. Please verify your account to enable login.';
                this.showChildModal();
            },
            error => {
                this.loading = false;
                this.conferror = true;
                this.pwdmsg = "Could not send mail. User not eligible.";

                this.logger.error(error);
                return throwError(error);
            }
            
        );   
    }
    
    public changeLang(langId) {
        localStorage.setItem('langId', langId);
        this.eventsEmitterService.languageChange.emit(langId);
        this.translate.use(langId);
      }                    
}